const Hide = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.222 5.136a.5.5 0 0 0 0 .707L7.169 7.79q-1.665 1.189-2.71 3.166a1.9 1.9 0 0 0-.186.519 3 3 0 0 0-.056.56 2.2 2.2 0 0 0 .242 1.01q1.179 2.231 3.15 3.459Q9.581 17.73 12 17.73q2.224 0 4.071-1.038l2.586 2.585a.5.5 0 1 0 .707-.707L5.929 5.136a.5.5 0 0 0-.707 0m10.103 10.81L13.7 14.322q-.73.545-1.7.545-1.2 0-2.033-.833T9.134 12q0-.97.545-1.7l-1.78-1.78Q6.106 9.757 5.079 12q1.032 2.254 2.838 3.492Q9.723 16.731 12 16.731q1.812 0 3.325-.784"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.921 12a9.5 9.5 0 0 1-.972 1.672.54.54 0 0 0 .043.7.49.49 0 0 0 .745-.044 10 10 0 0 0 .804-1.284q.13-.241.186-.507a2.6 2.6 0 0 0 0-1.075 1.9 1.9 0 0 0-.186-.506q-1.18-2.233-3.15-3.46Q14.419 6.27 12 6.27q-.488 0-.958.05c-.414.044-.562.54-.268.834a.55.55 0 0 0 .444.154q.384-.038.782-.038 2.277 0 4.083 1.239Q17.889 9.746 18.92 12"
    />
  </>
)
export default Hide
